import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import { signOutAdmin } from '../../services/auth';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.header`
  background: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 250px;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 1rem;
  }
`;

const Title = styled.h1`
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserEmail = styled.span`
  color: #666;
  font-size: 0.9rem;
`;

const LogoutButton = styled.button`
  background: #ff0202;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e00000;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const AdminHeader: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOutAdmin();
      navigate('/admin/login');
    } catch (error) {
      console.error('Çıkış yapılırken hata:', error);
    }
  };

  return (
    <HeaderContainer>
      <Title>Galaraf Admin Panel</Title>
      <UserInfo>
        <UserEmail>{user?.email}</UserEmail>
        <LogoutButton onClick={handleLogout}>
          Çıkış Yap
        </LogoutButton>
      </UserInfo>
    </HeaderContainer>
  );
};